import React, {useEffect, useRef} from 'react';

import styled from 'styled-components';

import {gt} from 'app/utils/i18n';

import type {VideoSerializedType} from 'sweet-types';

type Props = {
  ratio: string;
  width: number;
  height: number;
  video: VideoSerializedType;
  videoPlaceholder?: string;
  canAutoplay: boolean;
  videoStartedPlaying: (videoId: string) => void;
  videoStoppedPlaying: (videoId: string) => void;
};

const VideoHolderDiv = styled.div<{
  ratio: string;
}>`
  padding-bottom: ${({ratio}) => ratio};
`;

export const VideoObject = ({
  ratio,
  width,
  height,
  canAutoplay,
  videoPlaceholder,
  video,
  videoStartedPlaying,
  videoStoppedPlaying,
}: Props) => {
  const inputRef = useRef<HTMLVideoElement | null>(null);

  const onPlayMethod = () => {
    videoStartedPlaying(video.hashid);
  };
  const onStoppedPlayingMethod = () => {
    videoStoppedPlaying(video.hashid);
  };

  useEffect(() => {
    if (inputRef.current != null) {
      inputRef.current.addEventListener('play', onPlayMethod);
      inputRef.current.addEventListener('pause', onStoppedPlayingMethod);
      inputRef.current.addEventListener('ended', onStoppedPlayingMethod);

      return () => {
        if (inputRef.current != null) {
          inputRef.current.removeEventListener('play', onPlayMethod);
          inputRef.current.removeEventListener('pause', onStoppedPlayingMethod);
          inputRef.current.removeEventListener('ended', onStoppedPlayingMethod);
        }
      };
    }
  }, [inputRef.current]);

  return (
    <VideoHolderDiv className="embedded-obj" ratio={ratio}>
      <video
        ref={inputRef}
        width={width}
        height={height}
        controls={true}
        playsInline={true}
        autoPlay={canAutoplay}
        placeholder={videoPlaceholder}
        muted
        src={video.src_url}
      >
        {gt('This browser does not support video streaming')}
      </video>
    </VideoHolderDiv>
  );
};
